import { Preferences } from '@capacitor/preferences'
import type { Tab } from './types'
import { weeksAgo } from './money'

const KEY = 'tabofshame.tabs.v1'
const KEEP_WEEKS = 12

function isTab(value: unknown): value is Tab {
  if (!value || typeof value !== 'object') return false
  const tab = value as Tab
  return (
    typeof tab.id === 'string' &&
    typeof tab.createdAt === 'number' &&
    typeof tab.date === 'string' &&
    typeof tab.venue === 'string' &&
    (tab.kind === 'bar' || tab.kind === 'restaurant' || tab.kind === 'other') &&
    typeof tab.billCents === 'number' &&
    typeof tab.tipCents === 'number' &&
    typeof tab.tipPercent === 'number' &&
    (tab.source === 'manual' || tab.source === 'scan') &&
    (tab.autoGratCents === undefined ||
      (typeof tab.autoGratCents === 'number' &&
        Number.isFinite(tab.autoGratCents) &&
        tab.autoGratCents >= 0)) &&
    (tab.autoGratPercent === undefined ||
      (typeof tab.autoGratPercent === 'number' &&
        Number.isFinite(tab.autoGratPercent) &&
        tab.autoGratPercent >= 0))
  )
}

export function pruneOldTabs(tabs: Tab[], now = new Date()): Tab[] {
  return tabs.filter((tab) => weeksAgo(tab.date, now) < KEEP_WEEKS)
}

export async function loadTabs(): Promise<Tab[]> {
  try {
    const { value } = await Preferences.get({ key: KEY })
    if (!value) return []
    const parsed: unknown = JSON.parse(value)
    if (!Array.isArray(parsed)) return []
    return pruneOldTabs(parsed.filter(isTab))
  } catch {
    return []
  }
}

export async function saveTabs(tabs: Tab[]): Promise<void> {
  const next = pruneOldTabs(tabs).sort((a, b) => {
    if (a.date === b.date) return b.createdAt - a.createdAt
    return a.date < b.date ? 1 : -1
  })
  await Preferences.set({ key: KEY, value: JSON.stringify(next) })
}

export function newTabId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID()
  return `tab-${Date.now()}-${Math.random().toString(16).slice(2)}`
}
